@if (label) {
<label for="{{id}}" class="block text-lg text-grey-300 font-medium mb-1" [ngClass]="labelClass">
  {{label}}
  <span class="text-sm text-grey-500">
    {{secondaryLabel}}
  </span>
</label>
}

<!-- [cardNumber]="cardNumber"
  [cardExpiry]="cardExpiry" [appNoInput]="noInput"
     -->


@if (showPrefix ) {
<div class="w-full flex items-center gap-3 p-2 rounded-md border border-grey-800 bg-transparent placeholder-grey-800"
  [ngClass]="[inputClass, control.disabled ? '!bg-[#EDEDED] !opacity-50' : '']">
  <ng-content select="[prefix]"></ng-content>

  <input (focus)="onFocus($event)" (blur)="onBlur($event)" [appDecimal]="decimal" [appAmount]="amount"
    [appDigitsOnly]="digitsOnly" [appMaxLength]="maxLength" [appNoInput]="noInput" [autofocus]="autofocus"
    [autocomplete]="autocomplete" [id]="id" [formControl]="control" [type]="type" [placeholder]="placeholder"
    [readonly]="isReadonly" [attr.aria-describedby]="describedBy || null"
    class="w-full bg-transparent outline-none border-none placeholder-grey-800" />
</div>
} @else if (showSuffix ) {
<div class="w-full flex items-center gap-3 p-2 rounded-md border border-grey-800 bg-transparent placeholder-grey-800"
  [ngClass]="[inputClass, control.disabled ? '!bg-[#EDEDED] !opacity-50' : '']">

  <input (focus)="onFocus($event)" (blur)="onBlur($event)" [appDecimal]="decimal" [appAmount]="amount"
    [appDigitsOnly]="digitsOnly" [appMaxLength]="maxLength" [appNoInput]="noInput" [autofocus]="autofocus"
    [autocomplete]="autocomplete" [id]="id" [formControl]="control" [type]="type" [placeholder]="placeholder"
    [readonly]="isReadonly" [attr.aria-describedby]="describedBy || null"
    class="w-full bg-transparent outline-none border-none placeholder-grey-800" />
  <ng-content select="[suffix]"></ng-content>
</div>
} @else {
<input (focus)="onFocus($event)" (blur)="onBlur($event)" [appAmount]="amount" [appDigitsOnly]="digitsOnly"
  [appMaxLength]="maxLength" [appNoInput]="noInput" [autofocus]="autofocus" [autocomplete]="autocomplete" id="{{id}}"
  [formControl]="control" [ngClass]="inputClass" [type]="type" [placeholder]="placeholder" [min]="minValue"
  [max]="maxValue" [step]="step" [readonly]="isReadonly" [attr.aria-describedby]="describedBy || null"
  class="w-full px-3 py-2 border border-grey-800 bg-transparent placeholder-grey-800 rounded-md focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-[#EDEDED] disabled:opacity-50 read-only:bg-[#F7F7F7] read-only:cursor-default" />
}

@if (useDefaultError && (control.dirty && control.invalid)) {
<p class="text-red-500 text-xs mt-1">
  {{errorMessage}}
</p>
}